import { Box, Divider, FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

const ControllerMappingFilter = ({
    tenantValue,
    tenantRoles,
    changeTenantHandler,
    changeTenantRoleHandler,
    tenantRoleValue
}) => {
  return (
    <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={5}>
            <FormControl sx={{width:'100%'}} margin="dense">
                <InputLabel id="demo-simple-select-standard-label">Tenant</InputLabel>
                <Select
                    label="Tenant"
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={tenantValue || ''}
                    onChange={changeTenantHandler}
                >
                    <MenuItem value="">Select Tenant</MenuItem>
                    {/* <MenuItem value='1'>Home Energy</MenuItem> */}
                    <MenuItem value='2'>KPS NA</MenuItem>
                </Select>
            </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={5}>
            <FormControl sx={{width:'100%'}} margin="dense">
                <InputLabel id="demo-simple-select-standard-label">Tenant Roles</InputLabel>
                <Select
                    label="Tenant Roles"
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={tenantRoleValue || ''}
                    onChange={changeTenantRoleHandler}
                >
                    <MenuItem value="">Select Tenant Role</MenuItem>
                    {tenantRoles?.data?.map(list => (
                        <MenuItem value={list.id}>{list.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>
        </Grid>
        <Divider style={{marginTop:10,marginBottom:10}}></Divider>
    </Box>
  )
}

export default ControllerMappingFilter